import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import "./Layout.css";

export default function Navbar() {
  const publicUrl = process.env.PUBLIC_URL || "";
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  const onLogout = () => {
    logout();
    navigate("/", { replace: true });
  };

  const username = user?.username || "user";
  const role = user?.role ? String(user.role).toUpperCase() : "";

  return (
    <div className="top-navbar">
      <NavLink end to="/dashboard" className="nav-logo">
        <span className="nav-logo-mark" aria-hidden="true">
          <img
            className="nav-logo-image"
            src={`${publicUrl}/haemil-mark.svg`}
            alt=""
          />
        </span>
        <span className="nav-logo-title">
          <span className="nav-logo-title-main">HAEMIL</span>
          <span className="nav-logo-title-accent">MES</span>
        </span>
      </NavLink>

      <div className="nav-menu">
        <NavLink end to="/dashboard" className={({ isActive }) => (isActive ? "active" : "")}
        >
          대시보드
        </NavLink>
        <NavLink to="/hr" className={({ isActive }) => (isActive ? "active" : "")}
        >
          인사관리
        </NavLink>
        <NavLink to="/accounting" className={({ isActive }) => (isActive ? "active" : "")}
        >
          정보관리
        </NavLink>
        <NavLink to="/inbound" className={({ isActive }) => (isActive ? "active" : "")}
        >
          입고관리
        </NavLink>
        <NavLink to="/inventory" className={({ isActive }) => (isActive ? "active" : "")}
        >
          재고관리
        </NavLink>
        <NavLink to="/orders" className={({ isActive }) => (isActive ? "active" : "")}
        >
          생산관리
        </NavLink>
        <NavLink to="/dispatch" className={({ isActive }) => (isActive ? "active" : "")}
        >
          출고관리
        </NavLink>
        <NavLink to="/traceability" className={({ isActive }) => (isActive ? "active" : "")}
        >
          이력제관리
        </NavLink>
        <NavLink to="/sales" className={({ isActive }) => (isActive ? "active" : "")}
        >
          영업관리
        </NavLink>
        <NavLink to="/stocktaking" className={({ isActive }) => (isActive ? "active" : "")}
        >
          재고조사
        </NavLink>
        <NavLink to="/cs" className={({ isActive }) => (isActive ? "active" : "")}
        >
          CS관리
        </NavLink>
      </div>

      <div className="nav-right">
        <div className="nav-user">
          <span className="nav-user-label">
            {username}
            {role ? <span className="nav-user-role"> ({role})</span> : null}
          </span>
          <button className="btn secondary small no-hover nav-logout" onClick={onLogout}>
            로그아웃
          </button>
        </div>
      </div>
    </div>
  );
}
